/**
 * Labstep
 *
 * @module components/DeviceBooking/Form/ShowEdit/Description
 * @desc ShowEditDescription for DeviceBooking
 */

import { fieldDescription } from 'labstep-web/components/DeviceBooking/Form/fields';
import { FormShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import { DeviceBooking } from 'labstep-web/models/device-booking.model';
import type React from 'react';
import type { DeviceBookingFormShowEditDescriptionProps } from './types';

export const DeviceBookingFormShowEditDescription: React.FC<
  DeviceBookingFormShowEditDescriptionProps
> = ({ deviceBooking }) => (
  <FormShowEditText
    entityName={DeviceBooking.entityName}
    entity={deviceBooking}
    field={fieldDescription}
    placeholder="Add description"
  >
    {deviceBooking.description}
  </FormShowEditText>
);
